import { render, staticRenderFns } from "./Zeichnen.vue?vue&type=template&id=35b40c7c&scoped=true&"
import script from "./Zeichnen.vue?vue&type=script&lang=js&"
export * from "./Zeichnen.vue?vue&type=script&lang=js&"
import style0 from "./Zeichnen.vue?vue&type=style&index=0&id=35b40c7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b40c7c",
  null
  
)

export default component.exports